'use client';

import WorkspaceCTA from '../../v2/WorkspaceCTA';
import { SolutionSearchConsoleExpansion } from '../../SearchConsoleContentExpansion';
import TagsAndShare from '../TagsAndShare';
import YouMayAlsoLike from '../YouMayAlsoLike';
import SolutionHero from './SolutionHero';
import SolutionSidebar from './SolutionSidebar';

export default function SingleSolutionLayout2({ solution, title, description, content, image, url, slug, activeLang, t }) {
  return (
    <>
      <link rel="stylesheet" href="/assets/css/blog-layout-2.css" />
      <link rel="stylesheet" href="/assets/css/single-blog-layout-2.css" />
      <link rel="stylesheet" href="/assets/css/solutions-layout-2.css" />
      <link rel="stylesheet" href="/assets/css/content-layout-2.css" />
      <main className="blog-v2-page single-blog-v2-page solution-v2-single">
        <SolutionHero title={title} description={description} image={image} solutionsLabel={t('solutions:title')} />
        <section className="single-blog-v2-main">
          <div className="container blog-v2-container">
            <div className="single-blog-v2-columns">
              <article className="single-blog-v2-content solution-v2-content">
                <div dangerouslySetInnerHTML={{ __html: content }} />
                <SolutionSearchConsoleExpansion lang={activeLang} slug={slug} />
                <div className="solution-v2-cta"><WorkspaceCTA compact /></div>
              </article>
              <SolutionSidebar
                currentId={solution.id}
                popularTitle={t('solutions:popularSolutions')}
                guidesTitle={t('solutions:guidesAndResources')}
              />
            </div>
            <div className="single-blog-v2-footer solution-v2-footer">
              <section className="single-blog-v2-tags-share">
                <TagsAndShare tags={[]} title={title} url={url} hashtags={["digitalsignage", "adcast"]} twitterVia="adcastapp" />
              </section>
              <section className="single-blog-v2-related">
                <YouMayAlsoLike currentId={solution.id} currentSlug={solution.slug} />
              </section>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
